module.exports = __webpack_public_path__ + "static/media/close-icon.7c4bd045.svg";